import { SEO } from "@/components/SEO";
import { BooksHero } from "../components/site/books/BooksHero";
import { CollectionIntro } from "../components/site/books/CollectionIntro";
import { TheWordYouCarry } from "../components/site/books/TheWordYouCarry";
import { ChasingFireflies } from "../components/site/books/ChasingFireflies";
import { CurrentlyOnMyFloor } from "../components/site/books/CurrentlyOnMyFloor";
import { BooksCTA } from "../components/site/books/BooksCTA";

export default function Books() {
  return (
    <div data-testid="books-page">
      <SEO
        title="Books"
        description="Explore Lara Parrish's books — including The Word You Carry and Chasing Fireflies — stories and guides for building a life around joy."
        path="/books"
      />
      <BooksHero />
      <CollectionIntro />
      <TheWordYouCarry />
      <ChasingFireflies />
      <CurrentlyOnMyFloor />
      <BooksCTA />
    </div>
  );
}
